// Port of api/fuel/app/classes/insights/members/match.php

import Segment from 'offline/insights/segment'
import Constants from 'offline/constants'
import Rating from 'offline/model/rating'
import Util from 'offline/util'

export default Segment.extend({
	name: 'match',
	types: [Constants.TYPE_GROUP],
	insight: false,
	default_: false,
	detail: ['match'],
	run: function(type, owner, userIndex, detail, filter, vars) {
		var userA = parseInt(vars.user_a, 10)
		var userB = parseInt(vars.user_b, 10)
		var ratingsA = Rating.collection({
			where: [
				['user_id', '=', userA]
			]
		}).associated('game_id')
		var ratingsB = Rating.collection({
			where: [
				['user_id', '=', userB]
			]
		}).associated('game_id')
		var gameIndex = Object.keys(ratingsA).filter(function(gameId) { return ratingsB[gameId] })
		var matches = []

		for (var i = 0; i < gameIndex.length; i++) {
			var gameId = parseInt(gameIndex[i], 10)
			this._references.games.push(gameId)
			matches.push({
				game: gameId,
				user_a: parseFloat(ratingsA[gameIndex[i]].get_rating_value()),
				user_b: parseFloat(ratingsB[gameIndex[i]].get_rating_value()),
				diff: Math.abs(parseFloat(ratingsA[gameIndex[i]].get_rating_value()) - parseFloat(ratingsB[gameIndex[i]].get_rating_value()))
			})
		}

		matches = Util.sort_by_field(matches, 'diff', 'desc')

		return {
			matches: matches
		}
	}
})
